import { Button, Card, Col, Form, Row, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../../../firebase";
import { collection, doc, updateDoc } from "firebase/firestore";
import FormAction from "../../../../components/common/FormAction";

function MaintenanceInformation({ data, renderData, companyName }) {
  const [checked, setChecked] = useState(false);

  // const [form] = Form.useForm();
  const { id } = useParams();

  const defaultValues = {
    ownerSpecificNotes: data?.ownerSpecificNotes
      ? data?.ownerSpecificNotes
      : "",
  };
  const onFinish = async (values) => {
    // form.setFieldValue(values);

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const ownerRef = collection(companyDocRef, "owners");

    try {
      await updateDoc(doc(ownerRef, id), {
        maintenanceInformation: values,
      });
      message.success("Maintenance Information data Updated SuccessFully!");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.log(err);
      message.error(err.message);
    }
  };
  const onCancel = () => {
    setChecked(false);
  };

  const onFinishedFailed = async (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Maintenance Information data Update Failed!");
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Maintenance Information"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div>
              <Form
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                labelWrap={{ span: 8 }}
                onFinish={onFinish}
                onFinishedFailed={onFinishedFailed}
                initialValues={defaultValues}
              >
                <Col span={24}>
                  <Form.Item
                    label="Owner specific notes"
                    name="ownerSpecificNotes"
                  >
                    <TextArea rows={8} />
                  </Form.Item>
                </Col>
                <FormAction
                  className="contact-actions"
                  submit={"submit"}
                  cancel={onCancel}
                />
              </Form>
            </div>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Owner specific notes">
                <p>
                  {data?.ownerSpecificNotes ? data?.ownerSpecificNotes : "--"}
                </p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default MaintenanceInformation;
